import Draw from 'ol/interaction/Draw';
import { useContext, useEffect, useRef } from 'react'
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style';
import Text from 'ol/style/Text';
import { useDispatch } from 'react-redux';
import Snap from 'ol/interaction/Snap';
import { useState } from 'react';
import { MapContext } from '../../../map-container/map/MapContext';
import { never } from 'ol/events/condition';
import { useAppSelector } from '../../../../../state/hooks';
import { DigiPopup } from '../digi-popup/DigiPopup';
import { setCancelDigiActivate, setDigiPopupVisibility, setCalculatedFields, setFrom } from '../../../../../state/features/digitizationSlice';
import { DrawType, Mode, TransactWfs } from '../TransactWfs';
import { setButtonState } from '../../../../../state/features/buttonStateSlice';
import { ButtonState } from '../../../../shared/button-state/ButtonState';
import Feature from 'ol/Feature';
import calculateResult from './calculateResult';
import { GeomDataHolder } from '../../../panorama-container/easy-pano-imports';
import WKT from 'ol/format/WKT';
import { LineString, MultiPolygon } from 'ol/geom';
import { getArea, getLength } from 'ol/sphere';
import { setDrawState } from '../../../../../state/features/drawStateSlice';
import { DrawStateType } from '../../../../../util/model/drawState';
import VectorSource from 'ol/source/Vector';
import Overlay from 'ol/Overlay';

/* 
 * Bu componentle polygon geometri tipinde bir feature oluşrutuyoruz.
 *
*/
interface Props {
  source: any,
  finish?: any
}

export const DigiDrawPolygon = (props: Props) => {
  const map = useContext(MapContext);
  const dispatch = useDispatch();

  const [feature, setFeature] = useState<any>(undefined)
  const digiPopupVisibility = useAppSelector((state) => state.digitization.digiPopupVisibility)
  const transactStatus = useAppSelector(state => state.digitization.transactStatus)
  const cancelDigiActivate = useAppSelector((state) => state.digitization.cancelDigiActivate)
  const buttonState: any = useAppSelector(state => state.buttonState.buttonState)
  const leftClickCount = useRef(0);
  const from: string = useAppSelector(state => state.digitization.from)
  const isMobileScreen: number = useAppSelector((state: any) => state.styleControl.isMobileScreen)
  const overlayElementRef = useRef(document.createElement('div'));
  const overlays = useRef<Overlay[]>([]); 
/*   const [labelText, setLabelText] = useState<any>()
 */
/* const overlays: Overlay[] = [];  */
  let draw :any;
  const drawState = useAppSelector(state => state.drawState.value);

  useEffect(() => {
      if(drawState.drawStateType === DrawStateType.FINISH){
              const intrsDraw :any = (window as any).olMap.getInteractions().getArray().find((interaction:any)=> interaction instanceof Draw)
      
              if(isMobileScreen){

                  
                  intrsDraw?.finishDrawing();

              //  dispatch(setCancelDigiActivate(true))
                  /*
                  setTimeout(() => {
                      props.source.clear();
                  }, 1);
              */

                  //    dispatch(setButtonState(ButtonState.NONE));
                  //    dispatch(setDrawState({ drawStateType: DrawStateType.NONE }))
                  map.removeInteraction(draw)

                  
              }
      }
      
  }, [drawState]);
  useEffect(() => {
    const vectorSource = props.source;
    const featureForParallel: any = vectorSource.getFeatures()[0]
    if (featureForParallel) {
      const feature = new Feature()
      feature.setGeometry(featureForParallel.values_.geometry)
      setFeature(feature)
      dispatch(setDigiPopupVisibility(true))
      dispatch(setFrom("Map"))
    }
  }, [])

  useEffect(() => {
    if(digiPopupVisibility){
        const intrcts = (window as any).olMap.getInteractions().getArray()
        intrcts.forEach((interaction: any) => {
            if (interaction instanceof Draw) {
                map.removeInteraction(interaction)
            }
        });
    }
}, [digiPopupVisibility]);
   const createLengthOverlay = () => {
      const element = document.createElement('div');      
      element.className = 'length-label';
      return new Overlay({
        element: element,
        positioning: 'center-center',
        stopEvent: false,
        offset: [0, -10],
      });
    };

  useEffect(() => {
 

     draw = new Draw({
      source: props.source,
      type: 'Polygon',
      style: new Style({
        fill: new Fill({
          color: 'rgb(165, 33, 37, 0.44)',
        }),
        stroke: new Stroke({
          color: 'red',
          width: 2,
        }),
        image: new CircleStyle({
          radius: 5,
          fill: new Fill({
            color: 'red',
          }),
        }),
      }),
      finishCondition: never,
      condition: function (e: any) {
        //sadece solla çizim yapıyor ve sağla bitiriyor

        if (e.originalEvent.buttons === 1) {
          leftClickCount.current += 1;
          return true;
        } else if (e.originalEvent.buttons === 2) {
          if (leftClickCount.current < 3) {
            dispatch(setCancelDigiActivate(true))
            setTimeout(() => {
              props.source.clear();
            }, 1);

            dispatch(setButtonState(ButtonState.NONE));
            dispatch(setDrawState({ drawStateType: DrawStateType.NONE }))
            map.removeInteraction(draw)

            leftClickCount.current = 0;
            draw.finishDrawing();
            return false;
          }
          else {
            dispatch(setCancelDigiActivate(false))
            leftClickCount.current = 0;
            draw.finishDrawing();
            return true;
          }
        }
        else {
          return false;
        }
      },
    });

    let sketch: any = null;
    

   draw.on('drawstart', (event: any) => {
    if (event) {
      sketch = event.feature;  
      if (sketch) {
        sketch.getGeometry().on('change', (event: any) => {
          const geom = event.target;
          const coordinates = geom.getCoordinates()[0];
  
          
          overlays.current.forEach((overlay) => map.removeOverlay(overlay));
            overlays.current.length = 0;
  
          for (let i = 0; i < coordinates.length - 1; i++) {
            const start = coordinates[i];
            const end = coordinates[i + 1];
            const lineString = new LineString([start, end]);
            const segmentLength = getLength(lineString);
            const midPoint = [(start[0] + end[0]) / 2, (start[1] + end[1]) / 2];
            const overlay = createLengthOverlay();
            overlay.setPosition(midPoint);
            const element = overlay.getElement();            
            if (element) {
              element.innerHTML = `${segmentLength.toFixed(2)} m`;
            }
            
            map.addOverlay(overlay);
            overlays.current.push(overlay);
          }
        });
      }
    }
  });
    // (window as any).olMap.getLayers().getArray()
    // .filter((layer2: any) => layer2.getVisible())
    // .map((layer: any) => {
    //     const wms: any = layer;
    //     const _source = wms.getSource()
    //     if (_source instanceof VectorSource) {
    //         const snap = new Snap({
    //             source: _source
    //         });
    //         map.addInteraction(snap);
    //     }
    // })

    map.addInteraction(draw);
    drawEnd(draw);
    draw.on('drawend', async (event: any) => {
      map.removeInteraction(draw)
      // const polygonArea = event.feature?.getGeometry().getArea()

      const _geom = event.feature?.getGeometry().clone();
      const label = getArea(_geom)//.toFixed(2) + 'm';

      // setTextAfterDrawEnd(event, label)

      // setTextAfterDrawEnd(event, polygonArea)
      setFeature(event.feature)

      let geom;
      const wkt = new WKT();

      const _geomClone: any = event.feature.getGeometry().clone()
      geom = new MultiPolygon([_geomClone.transform('EPSG:3857', 'EPSG:4326').getCoordinates()]);
      const geomWktLine = wkt.writeGeometry(geom);
      geom.transform('EPSG:4326', 'EPSG:3857');
      const gdh: any = GeomDataHolder.fromWKT(geomWktLine);
      (window as any).panogl.getScalable().getMainSketchLayer().addGlobal(gdh);
      (window as any).panogl.getScalable().getMainSketchLayer().refresh();
      setTextAfterDrawEnd(event, gdh.attributes._areaSize)
      const calcFields = await calculateResult(event.feature);
      dispatch(setCalculatedFields(calcFields));


    });
    const content = map.getTargetElement();
    content.addEventListener('contextmenu', (event: MouseEvent) => {
      map.removeInteraction(draw);
    });

    return () => {
      map.removeInteraction(draw)
      props.source.clear();
    /*   */
    }

  }, [map])
  
  const showSuccess = ()=>{
    props.finish()
  }

  const drawEnd = (draw: Draw) => {
    draw.on('drawend', (event: any) => {
        const _geom = event.feature?.getGeometry().clone();
        const label = getArea(_geom)//.toFixed(2) + 'm';

      /*   setLabelText(label) */
        if (label) {

            let geom;
            const wkt = new WKT();

            const _geomClone: any = event.feature.getGeometry().clone()
            geom = new MultiPolygon([_geomClone.transform('EPSG:3857', 'EPSG:4326').getCoordinates()]);
            const geomWktLine = wkt.writeGeometry(geom);
            geom.transform('EPSG:4326', 'EPSG:3857');
            const gdh: any = GeomDataHolder.fromWKT(geomWktLine);
            (window as any).panogl.getScalable().getMainSketchLayer().addGlobal(gdh);
            (window as any).panogl.getScalable().getMainSketchLayer().refresh();
            setTextAfterDrawEnd(event, gdh.attributes._areaSize);
            (window as any).panogl.getScalable().getMainSketchLayer().removeFromGlobal(gdh);
            (window as any).panogl.getScalable().getMainSketchLayer().refresh();
             setTextAfterDrawEnd(event, label)
        }
    });
}
  /**
   * Çizim bittikten sonra ölçüm değerini çizilen nesnenin üzerine yazar. 
   */
  const setTextAfterDrawEnd = (event: any, polygonArea: any) => {
    dispatch(setDigiPopupVisibility(true))
    dispatch(setFrom("Map"))
    // polygonArea = polygonArea.toFixed(2);
    event.feature.setStyle(new Style({
      fill: new Fill({
        color: 'rgb(165, 33, 37, 0.44)',
      }),
      stroke: new Stroke({
        color: 'red',
        width: 2,
      }),
      image: new CircleStyle({
        radius: 5,
        fill: new Fill({
          color: 'red',
        }),
      }),
      text: new Text({
        text: `${polygonArea}`,
        font: "bold 15px 'Open Sans', 'Arial Unicode MS', 'sans-serif'",
        placement: 'point',
        offsetY: -15,
        fill: new Fill({
          color: 'white',
        }),
        stroke: new Stroke({
          color: 'black',
          width: 3,
        }),
      })

    }));
  }

  useEffect(() => {
    if (cancelDigiActivate) {
      props.source.clear();
      map.updateSize();
      if(!isMobileScreen){
        setFeature(undefined)
    }
    overlays.current.forEach((overlay) => map.removeOverlay(overlay));
      overlays.current.length = 0;
      dispatch(setCancelDigiActivate(false));
      // dispatch(setButtonState(ButtonState.NONE))
      const layer_:any = map.getLayers().getArray().find((el:any)=> el.getProperties().alias === 'draws')
      const draws:any = [...layer_.getSource().getFeatures().filter((el:any)=>el.get('alias') !== 'draws')]
      if(draws.length){
          layer_.getSource().clear();
          layer_.getSource().addFeatures(draws)
      }else{
          layer_.getSource().clear();
      }
    }
  }, [cancelDigiActivate,overlays])

  return (
    <>
      {digiPopupVisibility && from !== 'Panorama' && <DigiPopup mode={Mode.INSERT} title='Add New Feature' from='Map' />}
      {feature && feature?.getGeometry() && transactStatus && (buttonState === ButtonState.ADD || ((window as any).buttonState === ButtonState.ADD && (window as any).drawStartOfDigi) || buttonState === ButtonState.PARALLEL) && <TransactWfs coordinates={feature.getGeometry().getCoordinates()} finish={()=>{showSuccess()}} feature={feature} mode={Mode.INSERT} source={props.source} type={DrawType.POLYGON} />}
    </>
  )
}

